{
  "About": "Acerca de",
  "EditAbout": "editar acerca de",
  "about": "acerca de",
  "teamRoles": "roles de equipo",
  "Advisors": "Advisors",
  "TeamMemberTitle": "Título del miembro del equipo",
  "Save": "Guardar",
  "noTitle": "Sin título todavía",
  "Team": "Equipo",
  "Kudos": "Kudos",
  "BusinessCase": "Caso de negocio",
  "Delete": "Eliminar ",
  "FormerRebel": "Antiguo rebelde",
  "cancel": "Cancelar",
  "projectDescription": "Agrega una descripción de 1 a 3 frases sobre tu proyecto. Puede utilizar tu propuesta de valor desarrollada en el desafío de la solución. Max 250 caracteres",
  "ChangesMade": "Cambios realizados",
  "ConfirmCancel": "¿Estas seguro que quieres cancelar?",
  "goBack": "No, vuelve",
  "YesCancel": "Si, cancelar",
  "EmptyProjectDescription": "Hmmm... vacío. Declara tu proyecto al mundo rebelde.Hmmm... vacío. Declara tu proyecto al mundo rebelde.",
  "EmptyDescriptionPlaceHolder": "Añade una descripción de 1 a 3 frases sobre tu proyecto. Puedes utilizar tu propuesta de valor desarrollada en el desafío de soluciones. Máximo 250 caracteres.",
  "EmptyProjectDescriptionPart1": "Hmmm ... Vacío. ",
  "DeclareYourProject": "Muestra tu proyecto al mundo rebel.",
  "ClickHere": "haz clic aquí ",
  "EmptyProjectDescriptionPart2": "y muestra tu proyecto al mundo rebel",
  "EmptyProjectDescriptionPart3": "Esta descripción esta en progreso",
  "EmptyProjectDescriptionPart4": "( como todos nosotros)",
  "uploadBackdrop": "Añadir portada",
  "changeLogo": "Cambiar logo",
  "backdrop": "portada",
  "based": "Establecido en",
  "industry": "industria",
  "Name": "Nombre",
  "stage": "Estado",
  "description": "Descripción",
  "Location": "Ubicación",
  "ProjectDetails": "detalles del proyecto",

  "LoadingYourContent": "Cargando tu contenido ...",
  "editTopic": "editar tema",

  "EditBackground": "Editar Fondo",
  "EditDetails": "Editar detalles",

  "RequiredField": "Este campo es obligatorio",
  "MaximumLengthExceeded": "Se excede la longitud máxima",
  "Brief": "Resumen",
  "ProjectOwner": "Propietarios del Proyecto",
  "ProjectAdmin": "Administradores del Proyecto",
  "ProjectMember": "Miembros del Proyecto",
  "ProjectSupporter": "Colaboradores del Proyecto",
  "Supporters": "Partidarios",
  "Note": "Nota",
  "Notes": "Notas",
  "TellMeWhatYouThink": "Dime que piensas",
  "UnableToSaveProjectProfile": "No se pudo guardar el perfil del proyecto"
}
